import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
	setErrorPanel,
	setShowConfirmName,
} from '../../redux/utilities/utils.actions';
import { generateCertificate } from '../../redux/myCourse/myCourse.actions';
import { useForm } from 'react-hook-form';
import Modal from 'react-bootstrap/Modal';

const ConfirmName = ({
	fullName,
	setErrorMsg,
	error: { panelClass, panelMsg },
	generateCertificate,
	showConfirmName,
	setShowConfirmName,
}) => {
	const details = JSON.parse(localStorage.getItem('userDetails'));
	const [certificateName, setCertificateName] = useState(
		details?.full_name || fullName,
	);
	useEffect(() => {
		setCertificateName(details?.full_name || fullName);
	}, [details?.full_name, fullName]);

	const { register, handleSubmit } = useForm();

	const updateInfo = (data) => {
		if (data.fullName === '') {
			setErrorMsg({
				panelClass: 'alert alert-danger',
				panelMsg: 'Please enter your full name.',
			});
		} else {
			setCertificateName(data.fullName);
			setErrorMsg({
				panelClass: '',
				panelMsg: '',
			});
			generateCertificate({
				name: data.fullName,
			});
		}
	};

	return (
		<Modal
			show={showConfirmName}
			dialogClassName="modal-90w"
			onHide={() => setShowConfirmName(false)}
			backdrop="static"
			keyboard={false}
		>
			<Modal.Header closeButton className="border">
				<h5 className="modal-title">
					Please make sure your full name is correct before generating your
					certificate.
				</h5>
			</Modal.Header>
			<Modal.Body size="lg">
				<div className={panelClass}>{panelMsg}</div>
				<form onSubmit={handleSubmit(updateInfo)}>
					<div className="form-group">
						<label className="text-left" style={{ display: 'block' }}>
							Full Name:
						</label>
						<input
							type="text"
							className="form-control"
							name="fullName"
							placeholder="Full Name*"
							defaultValue={certificateName}
							ref={register}
						/>
					</div>
					<div className="form-group ">
						<button
							aria-label="generate"
							id="button"
							type="submit"
							value="test"
							className="btn btn-primary"
							onClick={updateInfo}
						>
							Generate
						</button>
					</div>
				</form>
			</Modal.Body>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	const { userDetails, utils } = state.rootReducer;
	return {
		fullName: userDetails.full_name,
		showConfirmName: utils.showConfirmName,
		error: utils.errorPanel,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		generateCertificate: (val) => dispatch(generateCertificate(val)),
		setErrorMsg: (obj) => dispatch(setErrorPanel(obj)),
		setShowConfirmName: (val) => dispatch(setShowConfirmName(val)),
	};
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
	ConfirmName,
);
